export default __webpack_public_path__ + "media/images/loading-649392c42135cc386d0e96570563a50a.gif";